import { ApiModule } from '@common/index';
import type { ReportColumn, ReportTable } from '../models';

export class ReportApi extends ApiModule {
  protected endpoint = '/report';

  public listTables() {
    return this.api.get<ReportTable[]>(`${this.endpoint}/list`);
  }

  public listColumns(table: string) {
    return this.api.get<ReportColumn[]>(`${this.endpoint}/columns?table=${encodeURIComponent(table)}`);
  }

  public downloadXls(table: string, columns: string[], academicYearCode?: string) {
    const params = new URLSearchParams();
    params.append('table', table);

    if (columns.length) {
      params.append('columns', columns.join(','));
    }

    if (academicYearCode) {
      params.append('academicYearCode', academicYearCode);
    }

    return this.api.get<Blob>(`${this.endpoint}/xls?${params.toString()}`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }
}
